export default "__VITE_ASSET__V8b6sfWv__"